import axios from 'axios';
import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { handleHttpError } from '../utils/common';
import { OnlyFansMetricType } from './useSextforceMetricsCampaignsOverview';
import { OnlyFansMetricsShareLinksType } from './useSextforcePublicMetric';

export interface OnlyFansMetricsPublicDataOverview {
    username: string;
    avatar?: string;
    metricId: string;
    name: string | null;
    type: OnlyFansMetricType;
    createdAt: Date | null;
    updatedAt: Date | null;
    trialUrl: string | null;
    campaignCode: string | null;
    counters: {
        countSubscribers?: number;
        countTransitions?: number;
        claimsCount?: number;
        subscribeCounts?: number;
        spendersCount?: number;
    };
}

export interface OnlyFansMetricsPublicOverviewResults {
    type: OnlyFansMetricsShareLinksType;
    name?: string;
    createdAt?: Date;
    results: OnlyFansMetricsPublicDataOverview | OnlyFansMetricsPublicDataOverview[];
}

const useSextforcePublicMetricOverview = (metricShareLinkId: string | undefined) => {
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();

    // Retrieve subscriber data
    const fetchMetric = async (): Promise<OnlyFansMetricsPublicOverviewResults> => {
        const query: string = `${settingsContext.routes.sextforce.publicMetrics}${metricShareLinkId}/overview`;

        return axios
            .get(query, {
                method: 'get',
                headers: {
                    apiKey: settingsContext.apiKey,
                },
            })
            .then(response => response.data);
    };

    return useQuery(['publicMetricOverview', metricShareLinkId], () => fetchMetric(), {
        refetchOnWindowFocus: false,
        staleTime: 0,
        enabled: metricShareLinkId ? true : false,
        retry: 0,
        onError: (error: any) => {
            if (error && error.response && error.response.data && error.response.data.status && error.response.data.status === 400) {
                dialog
                    .alert({
                        message: 'Link does not exist or expired',
                        title: 'Error',
                        ok: {
                            text: 'OK',
                            color: 'primary',
                            variant: 'contained',
                        },
                    })
                    .then(() => {});

                return null;
            }

            handleHttpError(error, dialog);
        },
    });
};

export default useSextforcePublicMetricOverview;
